export enum Account {
  SIGNIN = '/admin/account/signin',
}

export enum Acl {
  ROOT = '/acl',
}

export enum Search {
  ROOT = '/search',
  GLOBAL = '/global',
}

export enum User {
  ROOT = '/users',
  COMMUNITIES = '/users/${1}/communities',
  SUBSCRIPTIONS = '/users/${1}/subscriptions',
  SUBSCRIBERS = '/users/${1}/subscribers',
  SUBSCRIPTION_REQUESTS = '/users/${1}/subscription-requests',
  SUBSCRIBER_REQUESTS = '/users/${1}/subscriber-requests',
  REJECTED_SUBSCRIBER_REQUESTS = '/users/${1}/rejected-subscriber-requests',
  ME = '/users/me',
  RESTRICTIONS = '/users/restrictions',
  ACCESS = '/users/access',
  SUBSCRIBE = '/users/${1}/subscriptions',
  UNSUBSCRIBE = '/users/${1}/subscription-cancellations',
  STATUS = '/users/${1}/subscription-status-changes',
}

export enum AdminUser {
  ROOT = '/admin/users',
}

export const Exercise = {
  ROOT: '/admin/exercises',
  APPROVE_REQUESTED: '/admin/exercises/approve-requested',
  PUBLIC: '/admin/exercises/public',
  BY_ID: (id: string) => `/admin/exercises/${id}`,
  PUBLIC_APPROVE: (id: string) => `/admin/exercises/${id}/public-approve`,
  PUBLIC_REJECT: (id: string) => `/admin/exercises/${id}/public-reject`,
};

export enum ExerciseProperties {
  ROOT = 'admin/exercise-properties',
}

export enum ExerciseOption {
  ROOT = 'admin/exercise-options',
}

export enum Program {
  ROOT = '/programs',
  ITEM = '/item',
  COPY = '/copy',
  AVAILABLE = '/available',
  USER = '/users',
  EXERCISES = '/exercises',
}

export enum Training {
  ROOT = '/trainings',
  CURRENT = '/trainings/current',
  AVAILABLE = '/trainings/available',
  NEXT_STATUS = '/trainings/${0}/next-status',
  ITEM = '/trainings/${0}/item/${1}',
  // ITEM_STATUS = '/trainings/${0}/item/${1}/status',
  USER = '/trainings/${0}/users/${1}',
}

export enum Language {
  ROOT = '/admin/languages',
  ACTIVE = '/admin/languages/active',
}

export enum Translation {
  ROOT = 'admin/translations',
}

export enum Post {
  ROOT = '/posts',
  USER = '/posts/users',
  NEWS = '/posts/feed',
  COMMUNITY = '/posts/communities',
  COMMENT = '/posts/{0}/comments',
  COMMENT_REACTION = '/posts/{0}/comments/{1}/reactions',
  REACTION = '/posts/{0}/reactions',
}

export enum Community {
  ROOT = '/communities',
  SUBSCRIBERS = '/communities/${1}/subscribers',
  SUBSCRIBE = '/communities/${1}/subscriptions',
  UNSUBSCRIBE = '/communities/${1}/subscription-cancellations',
  REQUESTS = '/communities/${1}/requests',
  STATUS = '/communities/${1}/subscription-status-changes',
  MY = '/communities/my',
}

export enum Chat {
  ROOT = '/chats',
  MESSAGE = '/chats/${0}/messages',
  READ_MESSAGES = '/chats/${0}/read-receipts',
  CHAT_TYPING = '/chats/${0}/typing-events',
  UNREAD_MESSAGES = '/chats/unread-messages',
}

export enum Subscriptions {
  ROOT = '',
  PLANS = '/plans',
  PLAN_PRICES = '/plan-prices',
  RESTRICTIONS = '/restrictions',
}

export enum Payments {
  ROOT = '/payments',
  PLAN_SUBSCRIPTION = '/plans/${0}/subscriptions',
  CURRENT_SUBSCRIPTION = '/subscriptions/current',
  SETUP_INTENT = '/setup-intents',
}

export const BugReports = {
  ROOT: '/admin/bug-reports',
  TYPES: '/types',
  ARCHIVED: '/archived',
  REPORT_ID: (id: string) => `/${id}`,
  MESSAGE: (id: string) => `/${id}/messages`,
  STATUS: (id: string) => `/${id}/status`,
};

export const Sync = {
  ROOT: '/admin/sync',
  PROVIDERS: '/admin/sync/providers',
  MUSCLES: '/admin/sync/muscles',
  EXERCISES: '/admin/sync/exercises',
  MAPPINGS: '/admin/sync/mappings',
  RULES: '/admin/sync/rules',
};

export const AiAdmin = {
  ROOT: '/admin/ai',
  CHAT: '/admin/ai/chat',
  GENERATE_EXERCISE_DESCRIPTION: '/admin/ai/generate-exercise-description',
  TRANSLATE_MISSING: '/admin/ai/translate-missing',
};

export const AppCongig = {
  ROOT: '/admin/config',
  VARIABLE: '/variables',
  VARIABLE_ID: (id: string) => `/variables/${id}`,
  FEATURES: '/features',
  FEATURE_ID: (id: string) => `/features/${id}`,
  AI_PROMPTS: '/ai-prompts',
  AI_PROMPT_ID: (id: string) => `/ai-prompts/${id}`,
  FORMULAS: '/formulas',
  FORMULA_ID: (id: string) => `/formulas/${id}`,
  CACHE_RESET: '/cache/reset',
  FILE_PATHS: '/file-paths',
  FIREBASE_USER_VERIFY_EMAIL: '/firebase-user/verify-email',
  MIGRATE_PUBLIC_STORAGE_PATHS: '/storage/migrate-public-paths',
  MIGRATE_OWNER_STORAGE_PATHS: '/storage/migrate-owner-paths',
};

export const Agreements = {
  ROOT: '/admin/agreements',
  DOCUMENT_VERSIONS: (type: string) => `/documents/${type}`,
  DOCUMENT_ITEMS_BY_ID: (documentId: string) =>
    `/documents/by-id/${documentId}/items`,
  DOCUMENT_ITEMS_BY_TYPE_VERSION: (type: string, version: number) =>
    `/documents/${type}/versions/${version}/items`,
  CREATE_VERSION: (documentId: string) => `/documents/${documentId}/versions`,
  UPDATE_STATUS: (documentId: string) => `/documents/${documentId}/status`,
  CREATE_ITEM: '/items',
  UPDATE_ITEM: (itemId: string) => `/items/${itemId}`,
  DELETE_ITEM: (itemId: string) => `/items/${itemId}`,
  REORDER_ITEMS: '/items/reorder',
};

export const AdminNotifications = {
  ROOT: '/admin/notifications',
  TEMPLATES: '/admin/notifications/templates',
  TEMPLATE_BY_ID: (id: string) => `/admin/notifications/templates/${id}`,
  TRANSLATIONS: (templateId: string) =>
    `/admin/notifications/templates/${templateId}/translations`,
  TRANSLATION_BY_ID: (templateId: string, translationId: string) =>
    `/admin/notifications/templates/${templateId}/translations/${translationId}`,
  PREVIEW: '/admin/notifications/preview',
  CAMPAIGNS: '/admin/notifications/campaigns',
  CAMPAIGN_BY_ID: (id: string) => `/admin/notifications/campaigns/${id}`,
  DISPATCH_BULK: '/admin/notifications/dispatch/bulk',
};

export const AdminSupport = {
  ROOT: '/admin/support',
  REQUESTS: '/requests',
  ARCHIVED_REQUESTS: '/requests/archived',
  STATUS: (requestId: string) => `/requests/${requestId}/status`,
};

export const AdminAnalytics = {
  ROOT: '/admin/analytics',
  USAGE_EVENTS: '/usage-events',
};

export const TrainingActivityTypes = {
  ROOT: '/admin/training-activity-types',
  BY_ID: (id: string) => `/admin/training-activity-types/${id}`,
};
